import { UserSwitchOutlined } from "@ant-design/icons";
import { FC, useCallback } from "react";
import { AnyTask, Point } from "tm-shared/types";

import { useAppDispatch, useProtectedUserRoleSelector } from "@/hooks/redux";
import BaseButton from "@/shared/ui/BaseButton";
import { addModalToQueue } from "@/store/slices/ui";
import { ModalType } from "@/types/modals";
import { isManagerRole } from "@/utils/business/isManagerRole";

interface ICustomTaskFromTaskButton {
    point: Point;
    task: AnyTask;
    images: string[];
}

export const CustomTaskFromTaskButton: FC<ICustomTaskFromTaskButton> = ({
    point,
    images,
    task,
}) => {
    const dispatch = useAppDispatch();
    const role = useProtectedUserRoleSelector();
    const createCustomTaskForAgent = useCallback(async () => {
        if (images.length) {
            dispatch(
                addModalToQueue({
                    type: ModalType.CustomTaskAddPhotos,
                    id: ModalType.CustomTaskAddPhotos,
                    payload: {
                        point,
                        images,
                        task,
                    },
                }),
            );
        } else {
            dispatch(
                addModalToQueue({
                    type: ModalType.CreateCustomTask,
                    id: ModalType.CreateCustomTask,
                    payload: {
                        point,
                        images,
                    },
                }),
            );
        }
    }, [dispatch, images, point, task]);

    if (!isManagerRole(role)) return null;

    return (
        <BaseButton
            icon={<UserSwitchOutlined />}
            onClick={createCustomTaskForAgent}
        >
            Створити доручення
        </BaseButton>
    );
};
